import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import OnBoardingSteps from "../client/corporate/OnBoardingSteps.jsx";

export default function CorporateReviewDetails() {
  const { userId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const reviewStatus = searchParams.get("filter") || "Pending";

  return (
    <div className="max-w-full">
      <OnBoardingSteps
        userId={userId}
        step={10}
        isReviewMode={true}
        reviewStatus={reviewStatus}
        onReviewCompleted={() =>
          navigate(`/corporate_review?filter=${reviewStatus}`)
        }
      />
    </div>
  );
}